// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SignatureV1EnvelopeResendLatestResendLatestResponse {
    static getAttributeTypeMap() {
        return SignatureV1EnvelopeResendLatestResendLatestResponse.attributeTypeMap;
    }
}
SignatureV1EnvelopeResendLatestResendLatestResponse.discriminator = undefined;
SignatureV1EnvelopeResendLatestResendLatestResponse.additionalProperties = false;
SignatureV1EnvelopeResendLatestResendLatestResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=signatureV1EnvelopeResendLatestResendLatestResponse.js.map